<template>
  <div>
    <div v-if="productLinkList.items.length">
      <div 
        class="card shadow m-3 position-fixed right-0 top-0 pb-2"
        style="z-index: 10000; width: 400px;"
        ref="close"
      >
        <div class="card-body d-flex align-items-center" data-test="progress-update-product-link">
          <div
            :class="[productLinkList.progress < 100 ? 'rotate' : '']"
            class="
              mr-3
              rounded-round
              d-flex
              align-items-center
              justify-content-center
              p-2
              border-2 border-primary
              text-primary
            "
            style="width: 50px; height: 50px"
          >
            <i class="fa-solid fa-hourglass-half fa-2x" />
          </div>
          <div
            style="width: calc(100% - 100px);">
            <div 
              class="progress rounded-round mb-2" 
              style="height: 12px"
            >
              <div
                class="progress-bar bg-primary rounded-round"
                :style="`width:${productLinkList.progress}%;`"
              />
            </div>
            <div>
              {{ $t('Updating Product Link') }} ({{ productLinkList.name }})
            </div>
          </div>
          <button
            style="width: 50px;"
            @click="closeProgress()"
            type="button"
            class="close align-self-start ml-2 mr-n1 mt-n2 text-muted"
            point-none opacity-50
            :class="[productLinkList.progress >= 100 ? 'oint-none opacity-50' : '']"
          >
            <span>×</span>
          </button>
        </div>
        <div 
          v-if="itemList" 
          class="ml-3"
        >
          <a 
            href="#body-item" 
            class="collapsed font-size-sm text-underline custom-hover" 
            data-toggle="collapse"
          >
            <span>{{ $t('Response Message') }}</span> <i class="fa-light fa-angle-down" />
          </a>
        </div>
        
        <div    
          class="collapse" 
          id="body-item"
          style="max-height: 250px;overflow: scroll;"
        >
          <div 
            class="item-list pr-3" 
            style="padding-left: 55px" 
            v-for="(item, j) in productLinkList.items"  
            :key="'list'+j"
          >
            <div 
              class="item-log pt-2 pb-0" 
            > 
              <div>
                <span style="position: absolute; left: 20px;">
                  <img
                    v-if="item.channel_logo"
                    :src="item.channel_logo"
                    class="thumb25 rounded"
                    style="cursor: pointer;"
                  >
                  <img
                    v-else
                    :src="$storeIndex.getImageGobalAssets('')"
                    class="thumb35 rounded"
                  >
              </span>
                <span>{{ item.channel_name }}</span>
                <span  :class="[item.status ? 'text-success-300' : 'text-danger']">
                  <span><i class="fa-duotone fa-circle-check"></i> {{ $t(item.message) }}</span>
                  <span v-if="item.request_id"> - ({{ item.request_id }})</span>
                </span>
              </div>
              <div>{{ item.name }} <i class="fa-solid fa-angle-right"></i> <label class="text-danger">  {{ item.qty }}</label></div>
            </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
window.Pusher = require('pusher-js');
import Cookies from "js-cookie";
export default {
    data() {
        const vm = this;
        return {
            tenant: JSON.parse(Cookies.get('tenant')),
            isShow: false,
            productLinkList: {
              'progress' : 0,
              'items' : [],
            },
            itemList : [],

        }
    },
    methods: {
        closeProgress() {
          if (!localStorage.getItem('isCypress')) {
            if (this.websocket) {
                this.websocket.close();
            }
          }
          this.$store.dispatch("product/isModalModalUpdateProductLink", true);
          this.$nextTick(() => {
              this.$store.dispatch("product/isModalModalUpdateProductLink", false);
          });

        },
        getCurrentTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); 
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        openWebsocket(){
          let vm = this;
          let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
          const tenant = this.tenant;
          if(localStorage.getItem('isCypress')){
            let dataWebsocket = JSON.parse(localStorage.getItem('cypressDataWebsocket'));
              if (dataWebsocket) {
                dataWebsocket.forEach(data => {
                  let dataOnmessage = JSON.parse(JSON.stringify(data)) 
                  vm.websocketOnMessage(dataOnmessage ,user, tenant);
                }); 
              }   
          } else {
          ws.onopen = function open() {
              console.log('onopen')
              ws.send(JSON.stringify({
              "data": {
                  "clientUid": `request.product.link${tenant.id}`
              },
              "event": "subscribe"
              }));
          };
          ws.onmessage = function incoming(message) {
            let dataOnmessage = JSON.parse(message.data)      
              vm.websocketOnMessage(dataOnmessage , tenant);
            }
          }
        },

        websocketOnMessage (data , tenant) {
          // let data = JSON.parse(message.data)      
            if (data.event == `request.product.link`) {
              if(data.data.clientUid == `request.product.link${tenant.id}`){
                let items = data.data;

                if (!items.hasOwnProperty('product_link_id')) {
                    return
                }
                               
                let info = {
                  'id' : items.product_link_id,
                  'name' : items.product_link_name,
                  'total' : items.saleable_qty,
                  'progress' : ((1 / items.product_link_item_total) * 100),
                  'items' : [
                    {
                      "name" : items.product_name,
                      'channel_logo' : items.channel_logo,
                      'channel_name' : items.channel_name,
                      "request_id" : items.request_id,
                      "qty" : items.saleable_qty,
                      "message" : items.message,
                      "status" : items.status,
                      "id" : items.product_link_item
                    }
                  ]
                }

                let html = ""
                $(`#${items.product_link_item}`).text(items.saleable_qty)
                if(items.status){
                  html = '<span class="badge bg-success-400 px-2"><i class="fa-solid fa-check-circle mr-2" />'+vm.$t("_link.Updated")+'</span>'
                  $(`#status-${items.product_link_item}`).html(html)
                }

                if(!items.status){
                  html = '<span class="badge bg-danger-400 px-2"><i class="fa-solid fa-exclamation-triangle mr-2" />'+vm.$t("_link.Failed")+'</span>'
                  $(`#status-${items.product_link_item}`).html(html)
                }

                $(`#request-id-${items.product_link_item}`).html(vm.$t('Request ID') + ' : ' +items.request_id)
                $(`#message-${items.product_link_item}`).html(vm.$t('Message') + ' : ' +items.message)
                $(`#qty-${items.product_link_item}`).html(vm.$t('On Hand') + ' : ' +items.saleable_qty)
                $(`#time-${items.product_link_item}`).html(vm.$t('Last Updated') + ' : ' +vm.getCurrentTime())

                if(vm.productLinkList.items.length){
                  let item = {
                      "name" : items.product_name,
                      "request_id" : items.request_id,
                      "qty" : items.saleable_qty,
                      "message" : items.message,
                      "status" : items.status,
                      "id" : items.product_link_item,
                      'channel_logo' : items.channel_logo,
                      'channel_name' : items.channel_name,
                  }
                  vm.productLinkList.items.push(item)
                  vm.productLinkList.progress = ((vm.productLinkList.items.length / items.product_link_item_total) * 100)
                }else{
                  vm.productLinkList = info;
                }
              }
              if(data.data.clientUid == `request.product.link${tenant.id}` && data.event === 'ping') {
                ws.send(JSON.stringify({
                  "data": {
                    "clientUid": `request.product.link${tenant.id}`
                  },
                  "event": `pong`
                }))
              }
              if(vm.productLinkList.progress >= 100){
                vm.$store.dispatch("product/syncStockProgress", false);
                vm.$nextTick(() => {
                  vm.$store.dispatch("product/syncStockProgress", true);
                });
                vm.websocket.close();
              }
            }

        }
    },
    mounted() {
      // if (!localStorage.getItem('isCypress')) {

        this.openWebsocket();
        var vm = this;
        setTimeout(function(){
          vm.isShow = true;
        }, 5000);
      // }
    }
}
</script>

<style scoped>

.item-list {
    position: relative;
}

a.custom-hover {
    text-decoration: underline;
}

.item-list.pl-3.pr-3:last-child>.item-log {
    border-bottom: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/productlink/ModalUpdateProductLink.vue